import { createBrowserRouter } from "react-router-dom";
import AppLayout from "../components/layout/AppLayout";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import HomePage from "../pages/HomePage";
import SignInPage from "../pages/auth/SignInPage";
import SignUpPage from "../pages/auth/SignUpPage";
import VerifyEmailPage from "../pages/auth/VerifyEmailPage";
import designRoutes from "./designRoutes";
import strategyRoutes from "./strategyRoutes";
import buildRoutes from "./buildRoutes";

const router = createBrowserRouter([
  { path: "/signin", element: <SignInPage /> },
  { path: "/signup", element: <SignUpPage /> },
  { path: "/verify-email", element: <VerifyEmailPage /> },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <HomePage /> },
      {
        path: "design",
        children: designRoutes,
      },
      {
        path: "strategy",
        children: strategyRoutes,
      },
      {
        path: "build",
        children: buildRoutes,
      },
    ],
  },
]);

export default router;
